import React, { useState, useEffect } from 'react';
import bottleReturnService from '../../db/bottle-return-service';
import authService from '../../services/auth-service';
import './CustomerCreditsDisplay.scss';

const CustomerCreditsDisplay = () => {
  const [credits, setCredits] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadData();
    const interval = setInterval(loadData, 30000);
    return () => clearInterval(interval);
  }, []);

  const loadData = async () => {
    try {
      const customerId = authService.getCurrentUserId();
      if (!customerId) {
        setError('User not logged in');
        setLoading(false);
        return;
      }

      const creditsData = await bottleReturnService.getCustomerCredits(customerId);
      setCredits(creditsData);
      setError('');
    } catch (error) {
      console.error('Error loading credits data:', error);
      setError('Failed to load credits');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading credits...</div>;
  if (error) return <div className="error">{error}</div>;
  if (!credits) return <div className="error">No credits data available</div>;

  const availableCredits = credits.totalCredits - credits.usedCredits;
  const totalBottlesReturned = credits.history.filter(h => h.type === 'earned').length;
  const totalAmountRedeemed = credits.usedCredits;

  return (
    <div className="customer-credits-display">
      <div className="credits-summary">
        <div className="credit-card">
          <h3>💰 My Bottle Credits</h3>
          <div className="credit-stats">
            <div className="stat">
              <span className="label">Total Bottles Returned</span>
              <span className="value">{totalBottlesReturned}</span>
            </div>
            <div className="stat">
              <span className="label">Amount Redeemed</span>
              <span className="value">₹{totalAmountRedeemed}</span>
            </div>
            <div className="stat">
              <span className="label">Available Balance</span>
              <span className="value">₹{availableCredits}</span>
            </div>
            <div className="stat">
              <span className="label">Total Earned</span>
              <span className="value">₹{credits.totalCredits}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="requests-history">
        <h4>Transaction History</h4>
        {credits.history.length === 0 ? (
          <p className="no-requests">No transactions yet</p>
        ) : (
          <div className="history-table">
            <div className="table-header">
              <div className="col-date">Date</div>
              <div className="col-type">Type</div>
              <div className="col-amount">Amount</div>
              <div className="col-details">Details</div>
            </div>
            {credits.history.map((entry, idx) => (
              <div key={idx} className={`table-row ${entry.type}`}>
                <div className="col-date">
                  {new Date(entry.date).toLocaleDateString()}
                </div>
                <div className="col-type">
                  <span className={`badge ${entry.type}`}>
                    {entry.type === 'earned' && '📦 Earned'}
                    {entry.type === 'used' && '💳 Redeemed'}
                    {entry.type === 'manual_add' && '➕ Added'}
                  </span>
                </div>
                <div className="col-amount">₹{entry.amount}</div>
                <div className="col-details">
                  {entry.type === 'earned' && `${entry.bottleCount} bottles`}
                  {entry.type === 'used' && 'Subscription'}
                  {entry.type === 'manual_add' && 'Admin credit'}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomerCreditsDisplay;
